export const scrollToView = (id: string, blockCenter?: boolean) => {
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
    block: blockCenter ? 'center' : 'nearest'
  });
};
